/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountsettings_Unknowndevice2Inputs */

const zh_accountsettings_unknowndevice2 = /** @type {(inputs: Accountsettings_Unknowndevice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知设备`)
};

const en_accountsettings_unknowndevice2 = /** @type {(inputs: Accountsettings_Unknowndevice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown Device`)
};

const es_accountsettings_unknowndevice2 = /** @type {(inputs: Accountsettings_Unknowndevice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivo desconocido`)
};

/**
* | output |
* | --- |
* | "Unknown Device" |
*
* @param {Accountsettings_Unknowndevice2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const accountsettings_unknowndevice2 = /** @type {((inputs?: Accountsettings_Unknowndevice2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountsettings_Unknowndevice2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_accountsettings_unknowndevice2(inputs)
	if (locale === "en") return en_accountsettings_unknowndevice2(inputs)
	return es_accountsettings_unknowndevice2(inputs)
});
export { accountsettings_unknowndevice2 as "accountSettings_unknownDevice" }